import React from "react";

export const InviteIcon = ({ stroke = "#113357" }: { stroke?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path stroke={stroke} strokeLinecap="round" strokeLinejoin="round" d="M3 9.257h3.349M4.678 7.583v3.348"></path>
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M10.133 7.26a2.26 2.26 0 1 0 4.52 0 2.26 2.26 0 0 0-4.52 0M8 13.925a3.01 3.01 0 0 1 2.887-2.146h3.012a3.01 3.01 0 0 1 2.888 2.15"
      ></path>
    </svg>
  );
};
